import axiosInstance from "@/utils/axiosInstance";

const baseUrl: string = "api/connectors/connected-boxes";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getSize({commit}, payload: {
    externalId: string,
    provider: string,
  }): Promise<any> {
    return axiosInstance.get(`${baseUrl}/${payload.externalId}/size`, {
      params: {
        provider: payload.provider,
      },
    }).then((data) => data.data);
  },
  async simulateCodeUse({commit}, payload: {
    externalId: string,
    code: string,
  }): Promise<any> {
    return axiosInstance.post(`${baseUrl}/${payload.externalId}/simulate/${payload.code}`)
      .then((data) => data.data);
  },
  async openLockercell({commit}, payload: {
    lockersystem: number,
    lockercell: number,
  }): Promise<any> {
    return axiosInstance.post(
      `${baseUrl}/lockersystems/${payload.lockersystem}/lockercells/${payload.lockercell}/open`,
    ).then((data) => data.data);
  },
  async testConnection({commit}, payload: {
    externalId: string,
    provider: string,
  }): Promise<any> {
    return axiosInstance.post(`${baseUrl}/${payload.externalId}/connection`, {
      provider: payload.provider,
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
